import { render } from "./LanguageChange.vue?vue&type=template&id=575cdc77&scoped=true"
import script from "./LanguageChange.vue?vue&type=script&lang=js"
export * from "./LanguageChange.vue?vue&type=script&lang=js"

import "./LanguageChange.vue?vue&type=style&index=0&id=575cdc77&lang=css"
import "./LanguageChange.vue?vue&type=style&index=1&id=575cdc77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575cdc77"]])

export default __exports__